import { communityCardClickHandler, defaultSwiperOptions, getUnitType, toggleEl } from '../../../js/modules/utilities';
import { handleSaveEvent } from '../../../js/components/save-community';
import {closeQuickAction, handleOtherActions} from '../../../js/components/other-actions';
import { initQuickViewModal } from '../../../js/components/quick-view';
import { getCommunityList } from '../../../js/api/community';
import { rerenderCommunityList } from '../../../js/components/render-communites';

export const communitiesFilter = () => {
  let currentCommunitySection;
  const communitiesFilter = document.querySelector('aside.communities-filter')
  if (communitiesFilter) {
    let initialSelectedFilters;
    const buttonClose = document.querySelector("#close-community-filters");
    const applyButton = communitiesFilter.querySelector('#apply-btn');
    const clearAllButton = communitiesFilter.querySelector('#clear-all-btn');
    const selectedFilterContainer = communitiesFilter.querySelector('.selected-filters');
    const inputs = communitiesFilter.querySelectorAll('input:not(#show-more)');
    const container = communitiesFilter.querySelector('.container');

    const applyFilters = (body) => {
      const { templateId, locationId } = currentCommunitySection.dataset;
      return getCommunityList(locationId, templateId, body);
    }
    const applyHandler = () => {
      const selectedFilters = [...selectedFilterContainer.querySelectorAll('.selected-filters-value')];
      const InputFilters = [];
      selectedFilters.forEach((filter) => {
        const { rawValue, name } = filter.dataset;
        const inputFilter = InputFilters.find(el => el.FilterColumn === name);
        const filterValue = {
          RawValue: rawValue,
          IsSelected: true,
          Render: true,
        }
        if (inputFilter) {
          inputFilter.Values.push(filterValue);
        } else {
          InputFilters.push({
            Title: name,
            FilterColumn: name,
            Values: [filterValue],
          });
        }
      })
      const body = { InputFilters }
      communitiesFilter.classList.add('spinner')
      applyFilters(body)
        .then((res) => {
          closeFilters(null, true);
          if (res && res.communities) {
            const communitiesList = currentCommunitySection.querySelector('.communities-list');
            rerenderCommunityList(communitiesList, res.communities, true);
            const counter = currentCommunitySection.querySelector('#communities-counter');
            if (counter) {
              counter.dataset.counter = res.communities.length;
            }
            document.dispatchEvent(new CustomEvent("communitiesRendered", {
              bubbles: true,
              detail: body,
            }));
          }
        })
        .finally(() => {
          communitiesFilter.classList.remove('spinner')
        });
    }
    const clearAllHandler = () => {
      inputs.forEach((input) => {
        input.checked = false;
      })
      if (selectedFilterContainer) {
        selectedFilterContainer.innerHTML = '';
      }
    }
    const containerClickHandler = (e) => {
      if (!selectedFilterContainer) return;
      const addSelectedFilter = (key, value, name, rawValue) => {
        const span = document.createElement('span');
        span.classList.add('selected-filters-value');
        span.dataset.name = name;
        span.dataset.key = key;
        span.dataset.rawValue = rawValue;
        span.innerHTML = `
            ${value}
            <svg class="close-icon"><use xlink:href="#close"></use></svg>
          `;
        selectedFilterContainer.appendChild(span);
      }
      const { tagName, classList, id } = e.target
      if (tagName === 'INPUT' && id !== 'show-more') {
        const { name, type } = e.target;
        const { value, key, rawValue } = e.target.dataset;
        const selectedFilterItems = [...selectedFilterContainer.querySelectorAll('span')];
        if (type === 'radio') {
          selectedFilterItems.forEach((item) => {
            if (item.dataset.name === name) {
              item.remove();
            }
          })
        }
        let isAdded = false;
        let selectedItem;
        selectedFilterItems.forEach((item) => {
          if (item.dataset.name === name && item.dataset.key === key) {
            isAdded = true;
            selectedItem = item;
          }
        });
        if (isAdded) {
          selectedItem.remove();
          e.target.checked = false;
        } else {
          addSelectedFilter(key, value, name, rawValue);
        }
      }
      const spanHandler = (span) => {
        const { name, key } = span.dataset;
        const input = communitiesFilter.querySelector(`input[data-key="${key}"][name="${name}"]`);
        if (input) {
          input.checked = false;
          span.remove();
        }
      }
      if (tagName === 'SPAN' && classList.contains('selected-filters-value')) {
        spanHandler(e.target);
      }
      if ((tagName === 'svg' && classList.contains('close-icon')) ||
        (tagName === 'use' && e.target.getAttribute('xlink:href') === '#close')) {
        const span = e.target.closest('span');
        if (span) {
          spanHandler(span);
        }
      }
    }
    if (applyButton) {
      applyButton.addEventListener('click', applyHandler);
    }
    if (clearAllButton) {
      clearAllButton.addEventListener('click', clearAllHandler)
    }
    const outsideClickHandler = (e) => {
      if (e.target.classList.contains('communities-filter')) {
        closeFilters();
      }
    }
    const toggleEl = () => {
      const valueToHide = "none";
      const filtersModal = document.querySelector(".communities-filter");

      filtersModal.addEventListener('click', outsideClickHandler)

      if (filtersModal) {
        const filtersModalStyles = window.getComputedStyle(filtersModal);
        const isHidden = filtersModalStyles.display === valueToHide;
        filtersModal.style.display = isHidden ? "block" : valueToHide;
        if (isHidden) {
          document.body.classList.add('body--scroll-locked');
        } else {
          document.body.classList.remove('body--scroll-locked');
          filtersModal.removeEventListener('click', outsideClickHandler);
        }
      }
    };
    const closeFilters = (e, apply = false) => {
      const filtersModal = document.querySelector(".communities-filter");

      if (filtersModal) {
        filtersModal.style.display = "none";
        document.body.classList.remove('body--scroll-locked');
        filtersModal.removeEventListener('click', outsideClickHandler);
        if (!apply && selectedFilterContainer) {
          selectedFilterContainer.innerHTML = '';
          initialSelectedFilters.forEach((item) => selectedFilterContainer.appendChild(item));
        }
      }
    };
    if (buttonClose) {
      buttonClose.addEventListener("click", closeFilters);
    }
    if (container) {
      container.addEventListener('click', containerClickHandler);
    }
    document.addEventListener('openFilters', ((e) => {
      currentCommunitySection = e.detail.closest('.maa-communities');
      if (communitiesFilter) {
        toggleEl();
        const selectedFilters = selectedFilterContainer.querySelectorAll('.selected-filters-value');
        initialSelectedFilters = [...selectedFilters];
        updateCounter();
        inputs.forEach((input) => {
          input.checked = false;
        });
        selectedFilters.forEach((selectedFilter) => {
          const { key, name } = selectedFilter.dataset;
          const input = communitiesFilter.querySelector(`input[data-key="${key}"][name="${name}"]`);
          if (input) {
            input.checked = true;
          }
        });
      }
    }));

    if(selectedFilterContainer) {
      selectedFilterContainer.addEventListener('wheel', (e) => {
        selectedFilterContainer.scrollLeft += e.deltaY;
      });
    }
    const updateCounter = () => {
      const selectedFilters = selectedFilterContainer.querySelectorAll('.selected-filters-value');
      if (selectedFilters.length > 0) {
        clearAllButton.dataset.counter = `(${selectedFilters.length})`;
      } else {
        clearAllButton.dataset.counter = '';
      }
    }
    const setObserver = () => {
      const mutationConfig = { attributes: true, childList: true };
      const observer = new MutationObserver((mutations) => {
        updateCounter();
      });

      observer.observe(selectedFilterContainer, mutationConfig);
    }
    setObserver();
  }
}



// WEBPACK FOOTER //
// ./src/templates/components/communities-filter/communities-filter.js